import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { TrustCenterStandaloneService } from '@anecdotes/shared-trust-center';

@Component({
  selector: 'app-preview-link-customer',
  templateUrl: 'preview-link-customer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewLinkCustomerComponent {
  @HostBinding('class')
  private readonly classes = 'absolute left-1/2 top-5 transform -translate-x-1/2 text-center flex flex-col';

  customerUrl = '';

  constructor(private trustCenterStandaloneService: TrustCenterStandaloneService) {}

  setCustomer(): void {
    this.trustCenterStandaloneService.setCustomer(this.customerUrl);
    window.location.reload();
  }
}
